// extracted by mini-css-extract-plugin
module.exports = {"tabList":"MyOrders_tabList__2oWBz","categorySection":"MyOrders_categorySection__3yOOQ"};